import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Accordion, Text, View } from "native-base";
import { styles } from '../constants';

class BlockAccordion extends Component {
  handlerChange = (element) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      block,
      element
    });
  }

  _renderHeader(item, expanded) {
    return (
      <View style={styles.accordionHeader}>
        <Text style={styles.accordionText}>
          {" "}{item.title}
        </Text>
        {expanded
          ? <Icon style={styles.accordionText} name="ios-arrow-up" />
          : <Icon style={styles.accordionText} name="ios-arrow-down" />}
      </View>
    );
  }

  _renderContent(item) {
    return (
      <Text
        style={styles.accordionContent}
      >
        {item.content}
      </Text>
    );
  }
  render() {
    const { block, expanded } = this.props;

    let firstElementValue = block && block.elements && block.elements[0] ? block.elements[0].value : '';

    return (
      <Accordion
        renderHeader={this._renderHeader}
        renderContent={this._renderContent}
        style={{ flexGrow: 0 }}
        icon={'ios-arrow-up'}
        expandedIcon={'ios-arrow-down'}
        iconStyle={!firstElementValue ? { display: 'none' } : {}}
        expandedIconStyle={!firstElementValue ? { display: 'none' } : {}}
        dataArray={
          block.elements.map((element) => ({
            title: element.label,
            content: element.value
          })
          )
        }
        expanded={expanded} />
    );
  }
}

BlockAccordion.propTypes = {
  block: PropTypes.object,
  expanded: PropTypes.number,
  onChange: PropTypes.func
};

export default BlockAccordion;
